/** Shopify CDN: Minification failed

Line 13:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 15:5 Transforming const to the configured target environment ("es5") is not supported yet
Line 15:20 Transforming for-of loops to the configured target environment ("es5") is not supported yet

**/
function copyURI(evt) {
	evt.preventDefault();
	navigator.clipboard.writeText(window.location.href);
}

const copyLinks = document.querySelectorAll('.copy-btn');

for (const copyLink of copyLinks) {
	copyLink.addEventListener('click', copyURI)
}
